module.exports = __webpack_public_path__ + "images/_/programs/h2whoaHybrid/images/characters/ian_pointing_left-4596053eb82e04f727bdd744c3de0325.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/images/characters/ian_pointing_left.png
// module id = 2409
// module chunks = 2